import { cn } from "@aidkitorg/component-library";

const DEFAULT_SOURCE_ICON = "https://images.cdn.deck.co/link/Electric.png";

const SIZE_CLASS_NAMES = {
  "small": "w-8 h-8",
  "large": "w-16 h-16"
}

interface SourceLogoProps {
  logoUrl: string | null;
  size: "small" | "large";
}

export function SourceLogo({
  logoUrl,
  size,
}: SourceLogoProps) {
  return <object className={cn("rounded-full", SIZE_CLASS_NAMES[size])} data={logoUrl || DEFAULT_SOURCE_ICON} type="image/png">
    <img src={DEFAULT_SOURCE_ICON} />
  </object>;
}
